import { gql } from '@apollo/client';
import client from './ApolloClient';

export const createLike = async (userId, articleId) => {
  const CREATE_LIKE = gql`
    mutation CreateLike($data: LikeCreateInput!) {
      createLike(data: $data) {
        id
        userId
        articleId
        createdAt
      }
    }
  `;

  const { data } = await client.mutate({
    mutation: CREATE_LIKE,
    variables: {
      data: {
        user: { connect: { id: parseInt(userId, 10) } },
        article: { connect: { id: parseInt(articleId, 10) } },
      },
    },
  });

  return data.createLike;
};

export const deleteLike = async (likeId) => {
  const DELETE_LIKE = gql`
    mutation DeleteLike($where: LikeWhereUniqueInput!) {
      deleteLike(where: $where) {
        id
      }
    }
  `;

  const { data } = await client.mutate({
    mutation: DELETE_LIKE,
    variables: {
      where: { id: parseInt(likeId, 10) },
    },
  });

  return data.deleteLike;
};

export const getUserLikes = async (userId, articleId) => {
    const LIST_LIKES = gql`
      query listLikes($where: LikeWhereInput) {
        listLikes(where: $where) {
          id
          userId
          articleId
        }
      }
    `;
  
    const { data } = await client.query({
      query: LIST_LIKES,
      variables: {
        where: {
          userId: { equals: parseInt(userId, 10) },
          articleId: { equals: parseInt(articleId, 10) },
        },
      },
      fetchPolicy: 'no-cache',
    });
  
    return data.listLikes;
  };
